<template>
  <div>
    <b-row class="justify-content-center" style="width: 100%; height: 100; overflow: hidden;">
      <div class="col-md-12">
         <a href="/"><img :src="logo" style="width: 135px; float: left; padding: 8px;">
         </a>
      </div>
    </b-row>
  <div class="app flex-row align-items-center" v-bind:style="{ 'background-image': 'url(' + bg_img + ') !important', 'min-height': '92vh', 'background-repeat': 'repeat-x !important'}">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
               <div class="row">
               <div class="col-md-12" v-if="errorMessage.verifyemail">
                 <div :class="verfiy_color"  style="text-align:center;">{{errorMessage.verifyemail}}</div>
               </div>
             </div>
                <h1>Login</h1>
                <p class="text-muted">Sign In to your account</p>
                   <div v-if="hasErrors.message" style="color:red; margin-left:47px;  font-size: 11px; font-weight: bold" class="help-block" v-html="errorMessage.message">
                                        <!-- <strong>{{errorMessage.message}}</strong> -->
                                    </div>        
                   <div v-if="hasErrors.both" style="color:red; margin-left:47px;  font-size: 11px;" class="help-block" >
                                        <strong>{{errorMessage.both}}</strong>
                                    </div>                  
                <b-input-group class="mb-3">
                  <b-input-group-prepend><b-input-group-text>@</b-input-group-text></b-input-group-prepend>
                  <input type="text" class="form-control" placeholder="Email/Phone" name="both" id="both" v-model="loginData.both" required>
                  
                </b-input-group>
                 <div v-if="hasErrors.password" style="color:red; margin-left:47px;  font-size: 12px;" class="help-block">
                                        <strong>{{errorMessage.password}}</strong>
                                    </div>  
                <b-input-group class="mb-3">
                  <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                  <input type="password" class="form-control" placeholder="Password" v-model="loginData.password" id="password" name="password" required>
                </b-input-group>
                 <div v-if="hasErrors.companyname" style="color:red; margin-left:47px;  font-size: 11px;"  class="help-block">
                                        <strong>{{errorMessage.companyname}}</strong>
                 </div>
                <b-input-group class="mb-3">
                  <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                  <input type="text" class="form-control" placeholder="Company ID" id="companyname" name="companyname" v-model="loginData.companyname" required>
                 
                </b-input-group>
                <b-input-group class="mb-3">
                    <div class="form-check form-check-inline mr-1">
                            <input class="form-check-input" id="check1" type="checkbox" v-model="remember">
                            <label class="form-check-label" for="check1">Remember</label>
                    </div>
                </b-input-group>
                <b-row>
                  <b-col cols="6">
                   
                    <b-button type="button" variant="primary" class="px-4" @click.prevent="loginPost()">Login</b-button>
                  </b-col>
                  <b-col cols="6" class="text-right">
                   <b-button type="button" variant="link" class="px-0" @click="resetmodel" >Forgot password?</b-button>
                    
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary p-4 d-md-down-none" style="background-color: #08051cb0 !important;width: 44%;">
              <b-card-body class="text-center">
                <div>
                  <h1>Sign up</h1>
                  <p style="font-size: 20px; margin-top: 58px;">For New User Please Click On Register Button.</p>
                  <b-button style="font-size: 18px;" :to="'/register'" variant="primary" class="active mt-3">Register</b-button>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
      <b-modal title="Forgot Password"  size="lg" class="modal-warning" v-model="warningModal" hide-footer  @ok="warningModal = true" ok-variant="warning">
             <div class="row">
               <div class="col-md-12" v-if="errorMessage.statusemail">
                 <div :class="status_color"  style="text-align:center;">{{errorMessage.statusemail}}</div>
               </div>
             </div>
    <b-row>
        
            <b-col sm="12">

              <b-form-group>
                <label for="name">Email</label>
                <b-form-input type="text" id="name1" placeholder="Email" v-model="resetemail"></b-form-input>
              </b-form-group>
            </b-col> 
             
          </b-row>
            <b-row>  
            <!-- warningmodel=true -->
            <b-col sm="3">
            <b-button type="button"  variant="primary" @click.prevent="reseturl" block>Verify</b-button>
          </b-col>
        </b-row>
    </b-modal>

     <b-modal title="Forgot Password"  size="lg" class="modal-warning" hide-footer v-model="warningModal1"  @ok="warningModal1 = true" ok-variant="warning">
         <div class="row">
               <div class="col-md-12" v-if="errorMessage.statusemail">
                 <div :class="status_color"  style="text-align:center;">{{errorMessage.statusemail}}</div>
               </div>
             </div>
      <b-row>
            <b-col sm="12">


              <b-form-group>
                <label for="name">Token Id</label>
                <b-form-input type="text" v-model="resettoken" placeholder="Otp"></b-form-input>
              </b-form-group>
            </b-col> 
             
          </b-row>
           <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="name">Password</label>
                <b-form-input type="text" v-model="resetpassword" placeholder="Password"></b-form-input>
              </b-form-group>
            </b-col> 
             
          </b-row>
           <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="name">Confirm Password</label>
                <b-form-input type="text"   v-model="resetpasswordconf" placeholder="Confirm Password"></b-form-input>
              </b-form-group>
            </b-col> 
             
          </b-row>
       

       <b-row>
            <b-col sm="3">
              <b-button  @click.prevent="loginPost1" variant="primary" block>Verify</b-button>
            </b-col>
       </b-row>
           
    </b-modal>
     <Spinner v-if="loading"></Spinner>
  </div>
</div>
</template>

<script>
import {mapState} from 'vuex'
import Spinner from '../../spinner.vue'

export default {
  name: 'Login',
  components :{
    Spinner
  },
  computed:{
    ...mapState({
      userStore: state=>state.userStore
    })
  },
  data()  {
    return {
      logo:null,
      bg_img:null,
      remember:0,
      loading:false,
      status_color:'alert alert-success',
      warningModal: false,
      warningModal1: false,
      resetemail:'',
      resetpassword:'',
      resettoken:'',
      resetpasswordconf:'',
      checkwarningmodel1:'',
      verfiy_color:'alert alert-success',
      loginData:{
        both:'',
        companyname:'',
        password:''
      },
      hasErrors:{
        both:false,
        companyname:false,  
        password:false,
        message:false
      },
      errorMessage:{
        verifyemail:null,
        both:null,
        companyname:null,
        password:null,
        message:null,
        statusemail:null
      }
    }
  },
  created(){
    this.logo = this.baseURL2 + '/design/img/logo.png';
    this.bg_img = this.baseURL2 + '/design/img/ban1.jpg';
    var is_remember = this.getCookie('is_remember')
    var company_id = this.getCookie('company_id')
    var username = this.getCookie('username')

    if(is_remember == 'true'){
      this.remember = true
      this.loginData.both = username
      this.loginData.companyname = company_id
    }

    this.test();
  },

  methods:{
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    test(){
      if(this.$route.query.id!=undefined ){
        this.verfiyemai();
      }
      else{
        this.$router.push('/');
      }
    },
    
    verfiyemai(){
      var _this=this
      var submit=0
      if(this.$route.query.id!=undefined ){
        if(this.$route.query.id.length<=50){
          this.$router.push('/');
          submit=1;
        }
        if(submit==0){
          this.$http.get('/api/users/confirm?uid='+this.$route.query.id+'')
          .then(function (response) {
            _this.verfiy_color="alert alert-success"
            _this.errorMessage.verifyemail="Account Activated Successfully"
              setTimeout(function() { 
                _this.verfiy_color="alert alert-success"
                _this.errorMessage.verifyemail=null
                _this.$router.push('/');
              }, 10000);
          })
          .catch(function (error) {
            _this.verfiy_color="alert alert-danger"
            _this.errorMessage.verifyemail="Token Has Been Expired"
            setTimeout(function() {
              _this.verfiy_color="alert alert-success"
              _this.errorMessage.verifyemail=null
              _this.$router.push('/');
            }, 10000);
          });
        }
      }
    },
    resetmodel(){
      if(this.checkwarningmodel1!=''){
        if(this.checkwarningmodel1 != 'open1'){
          this.warningModal1=true
        }
      }else{
        this.warningModal = true
      }
    },
    reseturl(){
      var _this=this
      var data ={
        email:this.resetemail
      }
      this.$http.post('/request-password-reset',data).then(function (response) {
        if(response.status==200){
          // console.log(response)
          _this.warningModal=false
          // _this.checkwarningmodel1='open1'
          // _this.errorMessage.statusemail="Please Check Your Email"
          _this.errorMessage.verifyemail="Please Check Your Email for Password Reset"
          _this.status_color='alert alert-success'
          setTimeout(function() { 
                _this.verfiy_color="alert alert-success"
                _this.errorMessage.verifyemail=null
                // _this.$router.push('/');
              }, 10000);
        }else{
          _this.errorMessage.statusemail="Please Try Again Or Email Id does Not exists"
          _this.status_color='alert alert-danger'
        }
      }).catch(function (error) {
        _this.errorMessage.statusemail=error.response.data.code
        _this.status_color='alert alert-danger'
      });
    },
    
    loginPost1(){
      var _this=this
      if(this.resetpassword===this.resetpasswordconf && this.resettoken!=''){
        var data={newPassword:this.resetpassword,
        confirmation:this.resetpasswordconf}
        // console.log(this.resettoken)
        this.$http.post('/api/users/reset-password?access_token='+this.resettoken,data).then(function (response) {
          _this.errorMessage.statusemail="Password Reset Successfully"
          _this.status_color='alert alert-success'
          _this.checkwarningmodel1=''
        }).catch(function (error) {
          _this.errorMessage.statusemail="Something Went Wrong :("
          _this.status_color='alert alert-danger'
        });
      }
      else if(this.resetpassword!==this.resetpasswordconf){
        _this.errorMessage.statusemail="Password Does Not Match"
        _this.status_color='alert alert-danger'
      }else{
        _this.errorMessage.statusemail="Please Provide Token Id "
        _this.status_color='alert alert-danger'
      }
    },
    
    loginPost(){
      var _this = this
      var vm = this.hasErrors
      var _vm = this.errorMessage
      if(this.loginData.both==='' || this.loginData.both===null ){
        vm.both = true
        _vm.both = "Required Phone/Email/Username"
      }
      else if(this.loginData.companyname==='' || this.loginData.companyname===null ){
        vm.companyname = true
        _vm.companyname = "Required companydomain"
      }
      else if(this.loginData.password==='' || this.loginData.password===null ){
        vm.password = true
        _vm.password = "Required Password"
      }
      else{
        this.loading=true
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var number=/^[0-9]{9,14}$/;
        if(re.test(this.loginData.both)===true)  {
          var log = {
            companyname: this.loginData.companyname.toUpperCase(),
            email: this.loginData.both.toLowerCase(),
            password: this.loginData.password,
          }
        }else if(number.test(this.loginData.both)===true){
          var log = {
            companyname: this.loginData.companyname,
            phone: this.loginData.both,
            password: this.loginData.password,
          }
        }else{
          var log = {
            companyname: this.loginData.companyname,
            username: this.loginData.both,
            password: this.loginData.password,
          }
        }

        if(this.remember){
          document.cookie = 'is_remember=true';
          document.cookie = 'company_id='+this.loginData.companyname;
          document.cookie = 'username='+this.loginData.both 
        }else{
          document.cookie = 'is_remember=false';
          document.cookie = 'company_id=';
          document.cookie = 'username='           
        }

        this.$http.post('/api/users/login', log).then(function (response) {
          if(response.status=== 200){
            _this.$store.dispatch('setUserObject',response.data.data1.id)
            localStorage.setItem('authUser', response.data.data1.id)
            localStorage.setItem('authUseremail', response.data.data1.email)
            var companyId = (log.companyname || '').toUpperCase()
            localStorage.setItem('companyId', companyId)
            if(log.email === 'i2oc@minsyst.com'){
              _this.$store.commit('set_is_admin', true)
            }
            else{
               _this.$store.commit('set_is_admin', false)
            }
            // _this.$store.commit('set_sale_view', response.data.data1.sales)
            // _this.$store.commit('set_sale_rights', response.data.data1.sales)
            // _this.$store.commit('set_salert_view', response.data.data1.sales)
            // _this.$store.commit('set_salert_rights', response.data.data1.sales)
            // _this.$store.commit('set_salerechis_view', response.data.data1.sales)
            // _this.$store.commit('set_salerechis_rights', response.data.data1.sales)
            // _this.$store.commit('set_saleinvoice_view', response.data.data1.sales)
            // _this.$store.commit('set_saleinvoice_rights', response.data.data1.sales)
            // _this.$store.commit('set_salerec_view', response.data.data1.sales)
            // _this.$store.commit('set_salerec_rights', response.data.data1.sales)

            // _this.$store.commit('set_pur_view', response.data.data1.purchase)
            // _this.$store.commit('set_pur_rights', response.data.data1.purchase)
            // _this.$store.commit('set_purrt_view', response.data.data1.purchase)
            // _this.$store.commit('set_purrt_rights', response.data.data1.purchase)
            // _this.$store.commit('set_purpay_view', response.data.data1.purchase)
            // _this.$store.commit('set_purpay_rights', response.data.data1.purchase)
            // _this.$store.commit('set_purpayhis_view', response.data.data1.purchase)
            // _this.$store.commit('set_purpayhis_rights', response.data.data1.purchase)

            localStorage.setItem('authUserstatus', response.data.data1.status)
            _this.$router.push('/authuser');

          }else{
            _this.loading=false
          }
        })
        .catch(function (error) {
          console.log(error)
          _this.loading=false
          vm.message = true
          _vm.message = error.response.data.error.message
        });
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/pages/Login.vue